import { createFileRoute, Navigate } from "@tanstack/react-router";

// Enlace directo anterior a la ficha: ahora la ficha es un panel lateral
// sobre la tienda (`/settings/apps?app=…`).
export const Route = createFileRoute("/_authenticated/settings/_layout/apps/$listingId")({
  component: AppDetailRedirect,
});

function AppDetailRedirect() {
  const { listingId } = Route.useParams();
  return <Navigate to="/settings/apps" search={{ app: listingId }} replace />;
}
